import React, { useRef } from "react"
import { StyleSheet, View } from "react-native"
import LottieView from "lottie-react-native"
import { ScreenSkeleton } from "../screens/ScreenSkeleton"
import TextM from "../components/text/TextM"
import { theme } from "../theme/theme"
import confetti2 from "../../../assets/animations/confetti-2.json"

export const CongratsTemplate = ({
    title,
    description,
    isLoading,
    children,
    bottomContent,
    error,
}) => {
    const lottieAnimationRef = useRef(null)

    return (
        <ScreenSkeleton
            isLoading={isLoading}
            withCenterContent
            bottomContent={bottomContent}
            errorScreenProps={{ error }}
        >
            <View style={{ paddingVertical: 40 }}>
                <View
                    style={{
                        width: "100%",
                        height: "100%",
                        alignSelf: "center",
                        position: "absolute",
                        top: 0,
                    }}
                >
                    <LottieView
                        autoPlay={true}
                        speed={0.7}
                        loop={false}
                        pointerEvents="none"
                        ref={lottieAnimationRef}
                        style={{
                            width: "100%",
                            alignSelf: "center",
                            position: "absolute",
                            top: 0,
                        }}
                        resizeMode="cover"
                        source={confetti2}
                    />
                </View>
                {/* Success Icon */}
                <View style={styles.successIcon}>
                    <TextM fontSize={80} color={theme.colors.success}>
                        🎉
                    </TextM>
                </View>

                {/* Header */}
                <View style={styles.header}>
                    <TextM
                        fontSize={28}
                        fontWeight="Black"
                        color={theme.colors.primary}
                        style={styles.title}
                        wrap
                    >
                        {title}
                    </TextM>
                    {description && (
                        <TextM fontSize={16} color={theme.colors.light} wrap>
                            {description}
                        </TextM>
                    )}
                </View>
                {children}
            </View>
        </ScreenSkeleton>
    )
}

const styles = StyleSheet.create({
    // Success icon
    successIcon: {
        alignItems: "center",
        marginBottom: 20,
    },

    // Header styles
    header: {
        alignItems: "center",
        marginBottom: 30,
        paddingHorizontal: 10,
    },
    title: {
        textAlign: "center",
        marginBottom: 16,
        lineHeight: 36,
    },
})
